// extracted by mini-css-extract-plugin
export var container = "_ex-1";
export var editor = "_ex-2";
export var resizable = "_ex-3";
export var wrapper = "_ex-0";